import request from '@/utils/request'

/**
 * 查询方案列表
 * @param data
 */
export const getSolution = (data) => {
  return request({
    url: '/sol/wap/solutions',
    method: 'get',
    params: data
  })
}

/**
 * 查询热词列表
 * @param data
 */
export const getSolutionHotKeyWords = (data) => {
  return request({
    url: '/sol/wap/solutions/hot_keyword',
    method: 'get',
    params: data
  })
}

/**
 * 根据关键字查询方案列表信息
 * @param data
 */
export const getSolutionByKeyWord = (data) => {
  let _data = {
    ...data,
    status: [ 'GROUNDING' ]
  }
  return request({
    url: '/sol/wap/solutions/bigDataSearch ',
    method: 'post',
    data: _data
  })
}

/**
 * 首页-方案热搜
 * @param data
 */
export const getSolutionHotSearch = (data) => {
  return request({
    url: '/sol/wap/solutions/hot',
    method: 'get',
    params: data
  })
}

/**
 * 方案列表查询接口
 * @param data
 */
export const getSolutions = (data) => {
  let _data = {
    ...data,
    status: [ 'GROUNDING' ]
  }
  return request({
    url: '/sol/wap/solutions/bigDataSearch ',
    method: 'post',
    data: _data
  })
}

/**
 * 根据方案id查询方案详情
 * @param id
 */
export const getSolutionsDetail = (id) => {
  return request({
    url: `/sol/wap/solutions/${id}`,
    method: 'get'
  })
}
/**
 * 根据方案id和用户名id查询方案详情
 * @param id
 */
export const getSolutionsDetailAndUserId = (pramas) => {
  return request({
    url: `/sol/wap/solutions/${pramas.id}`,
    method: 'get',
    params:{userId:pramas.userId}
  })
}
/**
 * 根据方案id查询相关方案
 * 最多5条
 * @param data
 */
export const getRelatedSolutions = (id, data) => {
  return request({
    url: `/sol/wap/solutions/${id}/relevance`,
    method: 'get',
    params: data
  })
}

/**
 * 根据业务Id获取图片
 * @param data
 */
export const getBizFile = (id) => {
  return request({
    url: `/sol/common/biz_file/${id}/pictures`,
    method: 'get'
  })
}

/**
 * 方案批量下载
 * @param bizId
 * @param email
 */
export const batchDownload = (bizId, email) => {
  return request({
    url: `/sol/wap/solutions/${bizId}/emailDownload`,
    method: 'post',
    data: {
      email: email
    }
  })
}
/**
 * 方案收藏
 * @param bizId
 * @param email
 */
export const  collect = (pramas) => {
  return request({
    url: `/sol/wap/solutions/collect`,
    method: 'post',
    data:pramas
  })
}
/**
 * 免费方案批量下载
 * @param bizId
 * @param email
 */
export const batchDownloadPay = (bizId, email) => {
  return request({
    url: `/sol/wap/solutions/${bizId}/payEmailDownload`,
    method: 'post',
    data: {
      email: email
    }
  })
}

/**
 * 增加下载次数
 * @param form
 */
export const addDownloadCount = (form) => {
  return request({
    url: '/sol/common/download/addCount',
    method: 'put',
    data: form
  })
}

/**
 * 创建限免订单
 * @param form
 */
export const createFreeOrder = (form) => {
  return request({
    url: '/sol/wap/activity/free/order',
    method: 'post',
    data: form
  })
}

/**
 * 查询下载次数
 * @param form
 */
export const queryDownloadCount = (form) => {
  return request({
    url: '/sol/common/download/auth',
    method: 'get',
    params: form
  })
}

/**
 * 查询下载码
 * @param bizId
 */
export const queryDownloadCode = (bizId) => {
  return request({
    url: `/sol/wap/solutions/${bizId}/FreeOrderdownloadCode`,
    method: 'get',
    params: {
      solutionId: bizId
    }
  })
}

/**
 * 查询限免订单是否存在
 * @param bizId
 */
export const queryFreeOrderExist = (bizId) => {
  return request({
    url: `/sol/wap/activity/free/${bizId}/exist`,
    method: 'post'
  })
}

/**
 * 创建平台订单信息
 */
export const creatOrderInfo = (data) => {
  return request({
    url: `/sol/wap/payment/creatOrderInfo`,
    method: 'post',
    data: data
  })
}

/**
 * 根据订单编号查询缓存订单信息
 */
export const getOrderInfoByOrderNo = (orderNo) => {
  return request({
    url: `/sol/common/getOrderInfoByOrderNo`,
    method: 'get',
    params: {
      orderNo: orderNo
    }
  })
}

/**
 * 创建支付订单,跳转收银台
 */
const normalizePaymentOs = (data) => {
  const paymentData = Object.assign({}, data)
  if (typeof paymentData.os === 'string' && paymentData.os.toLowerCase() === 'miniprogram') {
    paymentData.os = 'wap'
  }
  return paymentData
}

export const createOrder = (data) => {
  return request({
    url: `/sol/wap/payment`,
    method: 'post',
    data: normalizePaymentOs(data)
  })
}

/**
 * 获取平台唯一销售订单编号
 */
export const queryCreateOrderNo = () => {
  return request({
    url: `/polymerize-api/sol-api/solsmall/queryCreateOrderNo?time=${new Date().getTime()}`,
    method: 'get'
  })
}

/**
 * 校验下载权限
 */
export const checkDownloadAuth = (data) => {
  return request({
    url: `/sol/wap/payment/exist`,
    method: 'get',
    params: data
  })
}

/**
 * 获取用户河币数量
 */
export const getTotalCoin = (userId) => {
  return request({
    url: `/sol/common/hebi/${userId}`,
    method: 'get'
  })
}

/**
 * 个人中心支付订单,跳转收银台
 */
export const dealAwaitOrder = (orderNo, data) => {
  return request({
    url: `/sol/wap/payment/${orderNo}`,
    method: 'post',
    data: normalizePaymentOs(data)
  })
}

/**
 * 秒杀方案列表
 * @param data
 */
export const getSeckillList = (data) => {
  return request({
    url: '/sol/activity/seckill/solution/list',
    method: 'get',
    params: data
  })
}

/**
 * 每周推荐方案列表
 * @param data
 */
export const getTopList = (data) => {
  return request({
    url: '/sol/activity/seckill/solution/topList',
    method: 'get',
    params: data
  })
}

/**
 * 查询下载次数
 * @param form
 */
export const cancelOrder = (form) => {
  return request({
    url: '/sol/common/cancelOrder',
    method: 'get',
    params: form
  })
}

/**
 * @param data
 */
export const couponList = (params) => {
  return request({
    url: '/sol/coupon/list',
    method: 'POST',
    data: params
  })
}
/**
 * 获取方案文件地址
 */
export const getBizFileUrl = (id) => {
  return request({
    url: `/sol/common/biz_file/list?bizId=${id}&bizType=1`,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/solutions/solution.js